import marketTestInboxReducer from "./marketTestInboxReducer";

const marketTestInboxReducers = {
    marketTestInbox: marketTestInboxReducer,
}

export default marketTestInboxReducers;